/**
 * PEFSA · shipping estimate row in the cart summary (CHANGELOG-TEMA 2026-09-28 (83)).
 * Markup: snippets/pefsa-shipping-estimate.liquid. Styles: assets/pefsa-overrides.css.
 *
 * - One field: the postal code (CP). Country is Mexico; the state is DERIVED from the first two CP digits because
 *   Shopify requires one, while rates depend on the CP only (measured 2026-09-28). Deriving is not validating.
 * - Rates are requested only on the buyer's click, never on load (THEME_STATE.md, rule of 2026-09-27).
 * - A quote is kept for the session and shown again only while CP and cart signature are unchanged. After a cart or
 *   CP change the previous rates are not presented as current: the row reads "Por actualizar".
 * - Dates are shown only when the quote carries them.
 * - "Te faltan $X" is on or off from the snippet (data-route-gap); it needs the postal code list to match the
 *   store's local delivery zones.
 */
(function () {
  'use strict';
  if (!window.customElements || customElements.get('pefsa-shipping-estimate')) return;

  var STATES = [
    [1, 16, 'Ciudad de México'], [20, 20, 'Aguascalientes'], [21, 22, 'Baja California'], [23, 23, 'Baja California Sur'],
    [24, 24, 'Campeche'], [25, 27, 'Coahuila'], [28, 28, 'Colima'], [29, 30, 'Chiapas'], [31, 33, 'Chihuahua'],
    [34, 35, 'Durango'], [36, 38, 'Guanajuato'], [39, 41, 'Guerrero'], [42, 43, 'Hidalgo'], [44, 49, 'Jalisco'],
    [50, 57, 'México'], [58, 61, 'Michoacán'], [62, 62, 'Morelos'], [63, 63, 'Nayarit'], [64, 67, 'Nuevo León'],
    [68, 71, 'Oaxaca'], [72, 75, 'Puebla'], [76, 76, 'Querétaro'], [77, 77, 'Quintana Roo'], [78, 79, 'San Luis Potosí'],
    [80, 82, 'Sinaloa'], [83, 85, 'Sonora'], [86, 86, 'Tabasco'], [87, 89, 'Tamaulipas'], [90, 90, 'Tlaxcala'],
    [91, 96, 'Veracruz'], [97, 97, 'Yucatán'], [98, 99, 'Zacatecas']
  ];
  var ROUTE_NAMES = { 'local delivery': 'Ruta PEFSA', 'entrega local': 'Ruta PEFSA' };
  var DAYS = ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'];
  var MONTHS = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
  var CP_KEY = 'pefsa_cp';
  var QUOTE_KEY = 'pefsa_ship_quote';
  var QUOTE_MAX_AGE = 30 * 60 * 1000;
  // Measured 2026-09-28 on 16 real quotes: rates are ready 2.8 to 5.1 s after the request. A fixed 2.5 s wait
  // between polls added up to 2 s on top of that, so the first polls are short and then they space out. When the
  // carrier app does not answer, Shopify stays on 202 for ~13 s before its fallback: keep asking for 25 s.
  var POLL_STEPS = [600, 600, 600, 800, 800, 1000, 1000, 1500, 1500, 2000];
  var POLL_LAST = 2500;
  var POLL_BUDGET = 25000;
  var REQUEST_MS = 8000; // a single request that takes longer is cancelled and asked again
  var TEXT = {
    calculate: 'Calcular',
    update: 'Actualizar envío',
    loading: 'Calculando…',
    stale: 'Por actualizar',
    staleNote: 'Tu carrito cambió y el envío puede ser distinto.',
    free: 'Gratis',
    freeRoute: 'Gratis con Ruta PEFSA',
    from: 'desde ',
    parcelFrom: 'Paquetería desde ',
    show: 'Ver las {n} opciones',
    hide: 'Ocultar opciones',
    gapLead: 'Agrega ',
    gapMiddle: ' más y obtén ',
    gapReward: 'envío gratis',
    gapDone: '¡Ya tienes envío gratis con Ruta PEFSA!',
    partial: 'Escribe los 5 dígitos de tu código postal.',
    prefix: 'Revisa tu código postal: no corresponde a ningún estado.',
    invalid: 'Ese código postal no es válido. Revísalo.',
    network: 'No pudimos calcular el envío. Revisa tu conexión e inténtalo de nuevo.',
    timeout: 'No pudimos obtener las tarifas en este momento. Inténtalo de nuevo en unos minutos.'
  };

  function stateFor(cp) {
    if (!/^\d{5}$/.test(cp)) return null;
    var prefix = parseInt(cp.slice(0, 2), 10);
    for (var i = 0; i < STATES.length; i++) if (prefix >= STATES[i][0] && prefix <= STATES[i][1]) return STATES[i][2];
    return null;
  }
  function read(store, key) { try { return window[store].getItem(key); } catch (e) { return null; } }
  function write(store, key, value) { try { window[store].setItem(key, value); } catch (e) { /* storage blocked */ } }
  function drop(store, key) { try { window[store].removeItem(key); } catch (e) { /* storage blocked */ } }

  function money(amount) {
    var n = Number(amount);
    if (!isFinite(n)) return '';
    var text = n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    var template = window.priceFormatTemplate || '$ 0.00';
    return template.replace(/0([,.]0{0,2})?/, text).replace(/<[^>]*>/g, '');
  }
  function day(value) {
    var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(value || ''));
    if (!m) return '';
    var d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
    if (isNaN(d.getTime())) return '';
    return DAYS[d.getDay()] + ' ' + d.getDate() + ' ' + MONTHS[d.getMonth()];
  }
  function dateLabel(rate) {
    var range = rate.delivery_range;
    if (Array.isArray(range) && range.length) {
      var a = day(range[0]);
      var b = day(range[range.length - 1]);
      if (a && b && a !== b) return a + ' a ' + b;
      if (a) return a;
    }
    return day(rate.delivery_date);
  }
  function simplify(rates) {
    return rates.map(function (r) {
      var raw = String(r.presentment_name || r.name || '').trim();
      var name = ROUTE_NAMES[raw.toLowerCase()] || raw;
      return { n: name, p: Number(r.price), d: dateLabel(r), r: name === 'Ruta PEFSA' };
    }).filter(function (r) { return r.n && isFinite(r.p); });
  }
  function query(address) {
    return Object.keys(address).map(function (k) {
      return 'shipping_address[' + k + ']=' + encodeURIComponent(address[k]);
    }).join('&');
  }
  function request(method, body) {
    var options = { method: method, headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
    if (body) options.body = body;
    return options;
  }
  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  var routeList = null; // loaded only when the "Te faltan" notice is enabled
  var CELEBRATED_KEY = 'pefsa_route_celebrated';
  var confettiReady = null; // the library is downloaded only the first time it is needed

  /**
   * One short, small burst from the confirmation block. Runs only after a quote the buyer just asked for confirmed
   * the free route rate; never on load, reload or repaint. Skipped under reduced motion. The canvas does not take
   * pointer events, so nothing on the page is blocked.
   */
  function celebrate(src, anchor) {
    if (!src || !window.matchMedia || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!confettiReady) {
      confettiReady = new Promise(function (resolve, reject) {
        if (typeof window.confetti === 'function') return resolve();
        var script = document.createElement('script');
        script.src = src;
        script.async = true;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });
      confettiReady.catch(function () { confettiReady = null; });
    }
    confettiReady.then(function () {
      if (typeof window.confetti !== 'function') return;
      var box = anchor.getBoundingClientRect();
      window.confetti({
        particleCount: 40,
        spread: 55,
        startVelocity: 26,
        gravity: 1.1,
        scalar: 0.8,
        ticks: 110,
        zIndex: 2000,
        disableForReducedMotion: true,
        colors: ['#1a7f37', '#7cc58f', '#cfe6d6', '#004a97'],
        origin: {
          x: Math.min(0.98, Math.max(0.02, (box.left + box.width / 2) / window.innerWidth)),
          y: Math.min(0.98, Math.max(0.02, (box.top + box.height / 2) / window.innerHeight))
        }
      });
    }).catch(function () { /* the celebration is optional */ });
  }

  class PefsaShippingEstimate extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.value = this.querySelector('[data-value]');
      this.dest = this.querySelector('[data-dest]');
      this.destText = this.querySelector('[data-dest-text]');
      this.sub = this.querySelector('[data-sub]');
      this.gap = this.querySelector('[data-gap]');
      this.gapText = this.querySelector('[data-gap-text]');
      this.gapSub = this.querySelector('[data-gap-sub]');
      this.keepShopping = this.querySelector('[data-continue]');
      this.bar = this.querySelector('[data-bar]');
      this.total = this.querySelector('[data-total]');
      this.form = this.querySelector('[data-form]');
      this.field = this.querySelector('[data-field]');
      this.input = this.querySelector('input[name="zip"]');
      this.button = this.querySelector('[data-submit]');
      this.note = this.querySelector('[data-note]');
      this.options = this.querySelector('[data-options]');
      this.toggle = this.querySelector('[data-toggle]');
      this.list = this.querySelector('[data-list]');
      if (!this.form || !this.input || !this.button || !this.value || !this.list) return;
      if (!window.routes || !window.routes.cart_url) return;

      this.token = 0;
      this.signature = this.dataset.signature || '';
      this.form.addEventListener('submit', this.onSubmit.bind(this));
      this.input.addEventListener('input', this.onInput.bind(this));
      this.querySelector('[data-change]').addEventListener('click', this.edit.bind(this));
      this.options.addEventListener('toggle', this.label.bind(this));
      // In the cart drawer "Seguir comprando" is a button that closes the drawer; on the cart page it is a link.
      if (this.keepShopping && this.keepShopping.tagName === 'BUTTON') {
        this.keepShopping.addEventListener('click', function () {
          var drawer = this.closest('.modal');
          if (drawer && typeof drawer.hide === 'function') drawer.hide();
        });
      }
      this.onQuote = this.restore.bind(this);
      document.addEventListener('pefsa:ship-quote', this.onQuote);

      this.restore();
      this.ready = true;
      this.classList.add('is-ready'); // CSS shows the row and hides Krank's "Estimar envío" link from here on
    }

    disconnectedCallback() {
      this.token++;
      if (this.onQuote) document.removeEventListener('pefsa:ship-quote', this.onQuote);
    }

    /** Paints the state that matches what is stored; never calls Shopify. */
    restore() {
      var cp = read('localStorage', CP_KEY) || '';
      if (!/^\d{5}$/.test(cp) || !stateFor(cp)) return this.ask('');
      var quote = null;
      try { quote = JSON.parse(read('sessionStorage', QUOTE_KEY) || 'null'); } catch (e) { quote = null; }
      var fresh = quote && quote.cp === cp && Array.isArray(quote.rates) && quote.rates.length &&
        Date.now() - Number(quote.t) < QUOTE_MAX_AGE;
      if (fresh && quote.sig === this.signature) return this.show(cp, quote.rates);
      if (fresh) return this.stale(cp);
      this.ask(cp);
    }

    reset() {
      this.value.textContent = '';
      this.value.className = 'pefsa-ship__value';
      this.classList.remove('is-stale');
      this.classList.remove('has-total');
      this.gap.classList.remove('is-done');
      if (this.total) this.total.hidden = true;
      this.dest.hidden = true;
      this.sub.hidden = true;
      this.gap.hidden = true;
      this.options.hidden = true;
      this.options.open = false;
      this.list.textContent = '';
      this.form.hidden = false;
      this.field.hidden = false;
      this.button.textContent = TEXT.calculate;
      this.message('', false);
      this.busy(false);
    }

    ask(cp) {
      this.reset();
      this.input.value = cp;
      if (cp) this.describe(cp);
    }

    edit() {
      var cp = read('localStorage', CP_KEY) || '';
      this.token++;
      this.ask(cp);
      this.input.focus();
      this.input.select();
    }

    stale(cp) {
      this.reset();
      this.value.textContent = TEXT.stale;
      this.value.classList.add('is-stale');
      this.classList.add('is-stale');
      this.destination(cp);
      this.field.hidden = true;
      this.input.value = cp;
      this.button.textContent = TEXT.update;
      this.message(TEXT.staleNote, false);
    }

    destination(cp) {
      this.destText.textContent = 'A ' + cp + ' · ' + stateFor(cp);
      this.dest.hidden = false;
    }

    describe(cp) {
      var state = stateFor(cp);
      this.message(state ? 'Envío a ' + cp + ' · ' + state : TEXT.prefix, !state);
    }

    message(text, isError) {
      this.note.textContent = text;
      this.note.classList.toggle('is-error', !!isError);
      this.note.hidden = !text;
      if (isError) this.input.setAttribute('aria-invalid', 'true'); else this.input.removeAttribute('aria-invalid');
    }

    busy(on) {
      this.button.disabled = !!on;
      this.setAttribute('aria-busy', on ? 'true' : 'false');
      if (on) this.button.textContent = TEXT.loading;
    }

    label() {
      var count = this.list.children.length;
      this.toggle.textContent = this.options.open ? TEXT.hide : TEXT.show.replace('{n}', count);
    }

    onInput() {
      this.token++; // a pending answer for the previous CP must not paint
      this.busy(false);
      this.button.textContent = TEXT.calculate;
      var cp = this.input.value.replace(/\D/g, '').slice(0, 5);
      if (cp !== this.input.value) this.input.value = cp;
      if (cp.length < 5) return this.message('', false);
      this.describe(cp);
    }

    onSubmit(event) {
      event.preventDefault();
      if (this.button.disabled) return;
      var cp = this.input.value.replace(/\D/g, '');
      var state = stateFor(cp);
      if (!state) {
        this.field.hidden = false;
        this.message(cp.length === 5 ? TEXT.prefix : TEXT.partial, true);
        this.input.focus();
        return;
      }
      this.estimate(cp, state);
    }

    fail(mine, text) {
      if (mine !== this.token) return;
      this.busy(false);
      this.button.textContent = this.field.hidden ? TEXT.update : TEXT.calculate;
      this.field.hidden = false;
      this.message(text, true);
      if (this.keepFocus) this.input.focus();
    }

    estimate(cp, state) {
      var self = this;
      var mine = ++this.token;
      var address = { country: 'Mexico', province: state, zip: cp };
      var base = window.routes.cart_url;
      write('localStorage', CP_KEY, cp);
      drop('sessionStorage', QUOTE_KEY); // previous rates stop being current the moment a new quote starts
      this.message('', false);
      // The submit button is disabled while loading and loses focus: remember that the buyer was working here.
      this.keepFocus = this.contains(document.activeElement);
      this.busy(true);

      var started = Date.now();
      var pending = null; // the request in flight, so it can be cancelled

      // An empty list, a 202 or a slow answer all mean "not yet": Shopify gives no signal that tells "still
      // computing" from "no rates". So running out of time never claims there is no coverage; it only says the
      // rates could not be obtained now.
      function giveUp() {
        if (pending) { try { pending.abort(); } catch (e) { /* already settled */ } }
        self.fail(mine, navigator.onLine === false ? TEXT.network : TEXT.timeout);
      }
      // Hard stop: a request that never answers must not leave "Calculando…" on screen.
      var deadline = setTimeout(giveUp, POLL_BUDGET);
      function finish() { clearTimeout(deadline); }

      function call(url, options) {
        pending = typeof AbortController === 'function' ? new AbortController() : null;
        if (pending) options.signal = pending.signal;
        var own = pending;
        var timer = setTimeout(function () { if (own) own.abort(); }, REQUEST_MS);
        return fetch(url, options).then(
          function (r) { clearTimeout(timer); return r; },
          function (e) { clearTimeout(timer); throw e; }
        );
      }

      function again(attempt) {
        if (mine !== self.token) return finish();
        var wait = attempt < POLL_STEPS.length ? POLL_STEPS[attempt] : POLL_LAST;
        if (Date.now() - started + wait >= POLL_BUDGET) return; // the deadline timer closes the quote
        setTimeout(function () { poll(attempt + 1); }, wait);
      }

      function poll(attempt) {
        if (mine !== self.token) return finish();
        call(base + '/async_shipping_rates.json?' + query(address), request('GET'))
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (data) {
            if (mine !== self.token) return finish();
            var rates = data && data.shipping_rates;
            if (Array.isArray(rates) && rates.length) { finish(); return self.done(cp, simplify(rates)); }
            again(attempt);
          })
          .catch(function () { again(attempt); }); // a failed or cancelled poll is retried while there is time
      }

      call(base + '/prepare_shipping_rates.json', request('POST', JSON.stringify({ shipping_address: address })))
        .then(function (r) {
          if (mine !== self.token) return finish();
          if (r.status === 422) { finish(); return self.fail(mine, TEXT.invalid); }
          if (!r.ok) { finish(); return self.fail(mine, TEXT.timeout); }
          poll(0);
        })
        .catch(function () {
          if (mine !== self.token) return finish();
          finish();
          self.fail(mine, navigator.onLine === false ? TEXT.network : TEXT.timeout);
        });
    }

    done(cp, rates) {
      if (!rates.length) return this.fail(this.token, TEXT.timeout);
      write('sessionStorage', QUOTE_KEY, JSON.stringify({ cp: cp, sig: this.signature, rates: rates, t: Date.now() }));
      this.show(cp, rates);
      if (this.keepFocus) this.querySelector('[data-change]').focus();
      // Celebrate once per achievement: only here, on a quote just confirmed, and not again until the free route
      // rate has been lost and reached anew.
      var reached = rates.some(function (r) { return r.r && r.p === 0; });
      if (!reached) {
        drop('sessionStorage', CELEBRATED_KEY);
      } else if (read('sessionStorage', CELEBRATED_KEY) !== '1') {
        write('sessionStorage', CELEBRATED_KEY, '1');
        celebrate(this.dataset.confettiSrc, this.gap.hidden ? this : this.gap);
      }
      document.dispatchEvent(new CustomEvent('pefsa:ship-quote')); // the other instance (page or drawer) repaints
    }

    show(cp, rates) {
      this.reset();
      this.form.hidden = true;
      this.input.value = cp;
      this.destination(cp);

      var paid = rates.filter(function (r) { return r.p > 0; });
      var free = rates.filter(function (r) { return r.p === 0; });
      var lowest = paid.reduce(function (min, r) { return min === null || r.p < min ? r.p : min; }, null);
      var route = free.filter(function (r) { return r.r; })[0];

      if (free.length) {
        this.value.textContent = route ? TEXT.freeRoute : TEXT.free;
        this.value.classList.add('is-free');
        if (lowest !== null) {
          // One paid option is named as the quote names it; "Paquetería desde" only when there are several.
          this.sub.textContent = (paid.length === 1 ? paid[0].n + ' ' : TEXT.parcelFrom) + money(lowest) + '.';
          this.sub.hidden = false;
        }
      } else {
        this.value.textContent = (rates.length > 1 ? TEXT.from : '') + money(lowest);
        if (rates.length === 1) {
          this.sub.textContent = rates[0].n + (rates[0].d ? ' · ' + rates[0].d : '') + '.';
          this.sub.hidden = false;
        }
      }

      if (rates.length > 1) {
        var fragment = document.createDocumentFragment();
        rates.forEach(function (r) {
          var item = el('li');
          var text = el('span', 'pefsa-ship__option');
          text.appendChild(el('span', 'pefsa-ship__name', r.n));
          if (r.d) text.appendChild(el('span', 'pefsa-ship__date', ' · ' + r.d));
          item.appendChild(text);
          item.appendChild(el('span', 'pefsa-ship__price' + (r.p === 0 ? ' is-free' : ''), r.p === 0 ? TEXT.free : money(r.p)));
          fragment.appendChild(item);
        });
        this.list.appendChild(fragment);
        this.options.hidden = false;
        this.label();
      }

      if (route && this.total) {
        // The total is certain only when shipping is free; the note under it names the service it assumes.
        this.total.hidden = false;
        this.classList.add('has-total');
      }
      if (route) this.routeDone(); else this.routeGap(cp);
    }

    /** Confirmation: the same block, now saying the free route rate applies. */
    routeDone() {
      if (this.dataset.routeGap !== 'true' || !this.gapText) return;
      this.gapText.textContent = '';
      this.gapText.appendChild(el('b', '', TEXT.gapDone));
      if (this.gapSub) this.gapSub.hidden = true;
      if (this.keepShopping) this.keepShopping.hidden = true;
      if (this.bar) this.bar.style.width = '100%';
      this.gap.classList.add('is-done');
      this.gap.hidden = false;
    }

    /** "Te faltan $X" and its bar, at any cart amount: needs data-route-gap="true" and the CP on the list. */
    routeGap(cp) {
      if (this.dataset.routeGap !== 'true') return;
      var self = this;
      var mine = this.token;
      var minimum = Number(this.dataset.routeMinimum);
      var total = Number(this.dataset.total);
      if (!isFinite(minimum) || !isFinite(total) || total >= minimum) return;
      // One download per page, shared by the cart page and the drawer (the promise is cached, not the result)
      if (!routeList) {
        routeList = fetch(this.dataset.routeList)
          .then(function (r) { return r.ok ? r.json() : Promise.reject(new Error('HTTP ' + r.status)); })
          .then(function (data) {
            var zones = (data && data.cp_por_zona) || {};
            var codes = {};
            Object.keys(zones).forEach(function (zone) { zones[zone].forEach(function (code) { codes[code] = true; }); });
            return codes;
          });
        routeList.catch(function () { routeList = null; }); // a failed download may be retried on the next quote
      }
      routeList.then(function (codes) {
        if (mine !== self.token || !codes[cp]) return;
        if (!self.gapText) return;
        self.gapText.textContent = '';
        self.gapText.appendChild(document.createTextNode(TEXT.gapLead));
        self.gapText.appendChild(el('b', 'pefsa-ship__gap-amount', money((minimum - total) / 100)));
        self.gapText.appendChild(document.createTextNode(TEXT.gapMiddle));
        self.gapText.appendChild(el('b', '', TEXT.gapReward));
        if (self.gapSub) self.gapSub.hidden = false;
        if (self.keepShopping) self.keepShopping.hidden = false;
        // A sliver stays visible on very small carts so the bar still reads as a bar
        if (self.bar) self.bar.style.width = Math.max(4, Math.min(100, Math.round(total * 100 / minimum))) + '%';
        self.gap.hidden = false;
      }).catch(function () { /* the notice is optional: stay silent */ });
    }
  }

  customElements.define('pefsa-shipping-estimate', PefsaShippingEstimate);
})();
